const config = {
  // BASENAME : "/life-legacy/www/",  // For Build
  BASENAME: "",
  NODE_ENV: process.env.NODE_ENV,
  NAME_KEY: process.env.REACT_APP_NAME_KEY || "App",
  NAME_TITLE: process.env.REACT_APP_NAME_TITLE || "app",
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  RESUME_DOWNLOAD_URL: process.env.REACT_APP_RESUME_DOWNLOAD_URL,
  DEFAULT_LANGUAGE: process.env.REACT_APP_DEFAULT_LANGUAGE || "en",
  IMAGE_URL: process.env.REACT_APP_IMAGE_PATH,
  UNVERIFIED: "unverified",
  MAP_KEY:
    process.env.REACT_APP_MAP_API_KEY ||
    "AIzaSyCJ3cbkVpT8I5mr76uwkC6DihuapBJh9gI",
  STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
};

export default config;

export const GOOGLE_MAP_URL = (mapKey, libraries) =>
  mapKey &&
  `https://maps.googleapis.com/maps/api/js?key=${mapKey}&callback=initialize&sensor=false&libraries=${libraries}`;
